import { Image } from "./components/image/image";
import { Base } from "./content.base";

export const Content = Object.assign(Base, {
    Image: Image
});
